import { Button, Dropdown, MeetingActiveIcon, MeetingDefaultIcon } from '@bp/ui-components';
import { type FragmentType, getFragmentData, graphql } from 'client/gql';
import { useRunningPlannedMeetings } from '../../../../hooks/useCalendarEvents';
import { MeetingsFlyout } from '../../../MeetingFlyout/MeetingsFlyout';
import styles from '../_Flyouts.module.scss';

const HeaderMeetingsFlyoutFieldsDocument = graphql(`
  fragment HeaderMeetingsFlyoutFields on Query {
    ...CalendarEventMapCalendarEventsToBpEventTypeFields
    ...MeetingsFlyoutFields
  }
`);

const HeaderMeetingsFlyout = ({
  query,
}: {
  query: FragmentType<typeof HeaderMeetingsFlyoutFieldsDocument> | undefined;
}) => {
  const fragment = getFragmentData(HeaderMeetingsFlyoutFieldsDocument, query);
  const { runningMeetings } = useRunningPlannedMeetings(fragment);

  return (
    <Dropdown
      noPadding
      className={styles['flyout']}
      trigger={
        <Button
          hierarchy='tertiary'
          icon={runningMeetings.length > 0 ? <MeetingActiveIcon /> : <MeetingDefaultIcon />}
        />
      }
    >
      <MeetingsFlyout query={fragment} />
    </Dropdown>
  );
};

export { HeaderMeetingsFlyout };
